<template>
  <Public>
    <v-main>
      <v-container fluid>

        <v-row justify="center">
          <v-col md="6">
            <v-card>
              <v-card-title>Feature</v-card-title>
              <v-card-text class="text--primary">
                <p>
                  Nam facilisis lectus quam, vel pharetra dui elementum faucibus. Etiam pulvinar consequat nisl,
                  sit amet scelerisque lorem gravida a. Pellentesque ultricies neque in congue bibendum.
                  Integer est lorem, sollicitudin id dui eget, volutpat hendrerit mauris. Aenean ligula purus,
                  efficitur eget purus in, fermentum imperdiet nulla. Nam dictum nisl scelerisque metus ultricies
                  vulputate. Duis cursus turpis risus, ac pretium ipsum semper non. Fusce in ex et nunc sagittis tincidunt.
                </p>
                <p>
                  Duis eu rhoncus nunc. Sed gravida quis urna posuere fringilla. Sed est augue, faucibus vitae nunc non,
                  rhoncus elementum diam. Cras a placerat velit. Suspendisse non lacinia nibh. Proin dictum, dolor eget
                  placerat efficitur, urna dui laoreet lectus, at pellentesque libero urna pulvinar magna. Praesent eu
                  ullamcorper tellus. Vestibulum gravida porttitor sodales. Curabitur condimentum lectus quis enim
                  tristique bibendum. Integer velit nisl, tincidunt sed euismod sed, convallis eu mi. Aliquam auctor
                  imperdiet nisl in auctor. Aliquam congue, turpis vitae pharetra condimentum, orci libero convallis nibh,
                  rutrum fringilla odio odio quis metus. Suspendisse vel nisi vehicula, gravida ante sed, dapibus leo.
                  Ut dui eros, sagittis ac aliquam vel, dapibus in nisl. Vivamus rutrum nibh et massa ultricies,
                  vitae ullamcorper lacus iaculis. Suspendisse iaculis scelerisque viverra.
                </p>
                <p>
                  Mauris maximus turpis non nunc maximus, sit amet efficitur dolor accumsan. Vestibulum auctor urna
                  ac volutpat dictum. Sed vel vestibulum massa. Quisque fermentum ligula vitae lectus facilisis,
                  nec elementum ipsum rutrum. Sed pharetra turpis in dolor congue mollis. Vestibulum vulputate
                  fringilla velit, ornare lobortis velit sagittis ut. Sed mollis dapibus posuere. Quisque vel tempor
                  sapien, malesuada porttitor purus.
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

      </v-container>
    </v-main>
  </Public>
</template>

<script>
  import Public from '@/components/public/public-main-template'

  export default {
    name: 'Home',
    components: {
      Public,
    }
  }
</script>

<style lang="scss">
  img {
    width: 100%;
  }
</style>
